import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Stack,
  Typography,
} from "@mui/material";
import ConfirmationDialog from "components/ConfirmationDialog";
import React from "react";
import { useDispatch } from "react-redux";
import addURLPrefix from "utils/addURLPrefix";
import { deleteSubCategoriesThunk } from "store/reducers/product/subCategorySlice";

const SubCategoryCard = ({ subCategory, updateSubCategory }) => {
  const dispatch = useDispatch();
  const [deleteDialog, setDeleteDialog] = React.useState(false);
  const handleDialogClose = () => {
    setDeleteDialog(false);
  };
  const deleteActions = () => (
    <>
      <Button onClick={handleDialogClose}>Cancel</Button>
      <Button
        onClick={() => dispatch(deleteSubCategoriesThunk(subCategory.id))}
        autoFocus
        color="danger"
      >
        Remove
      </Button>
    </>
  );
  return (
    <Card sx={{ width: 200 }} elevation={2}>
      {subCategory.image ? (
        <CardMedia
          component="img"
          height={140}
          image={addURLPrefix(subCategory.image)}
          alt=""
        />
      ) : (
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{ height: 140, backgroundColor: "gray" }}
        >
          <Avatar variant="round" sx={{ height: 80, width: 80 }}>
            {subCategory.name[0]}
          </Avatar>
        </Stack>
      )}

      <CardContent sx={{ paddingY: 0, paddingX: 2, marginY: 0 }}>
        <Typography gutterBottom variant="h5" component="div" marginTop={1}>
          {subCategory.name}
        </Typography>
        <Stack direction="row" sx={{ margin: 0 }}>
          <Typography gutterBottom variant="caption" component="div">
            Validation required :
          </Typography>
          <Typography
            gutterBottom
            variant="overline"
            component="div"
            marginLeft={2}
            paddingY={0}
            color={subCategory.validation_required ? "green" : "blue"}
          >
            {subCategory.validation_required ? "Yes" : "No"}
          </Typography>
        </Stack>
      </CardContent>
      <CardActions
        sx={{
          paddingY: 0.5,
          marginY: 0,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button
          size="small"
          color="primary"
          onClick={() => updateSubCategory(subCategory)}
        >
          Update
        </Button>
        <Button
          size="small"
          color="error"
          onClick={() => setDeleteDialog(true)}
        >
          delete
        </Button>
      </CardActions>
      <ConfirmationDialog
        open={deleteDialog}
        handleClose={handleDialogClose}
        title="Action required"
        body="Do you want to remove this item ?"
      >
        <Button onClick={handleDialogClose}>Cancel</Button>
        <Button
          onClick={() => dispatch(deleteSubCategoriesThunk(subCategory.id))}
          autoFocus
          color="error"
        >
          Remove
        </Button>
      </ConfirmationDialog>
    </Card>
  );
};

export default SubCategoryCard;
